import { createApi } from '@reduxjs/toolkit/query/react';
import { PdfCreateRequest } from '../../Components/OCV/OCVTypes';

import { FindMenuItemsResponse } from '../../Types/OcvInterface';
import { getBaseQuery, getBaseUrl } from '../../Utils';

export const objectViewerApi = createApi({
  reducerPath: 'objectViewerApi',
  baseQuery: getBaseQuery( getBaseUrl() + '/API/v3/' ),
  endpoints: (builder) => ({
    fetchObject: builder.mutation({
      query: (body) => ({
        url: body.url,
        method: 'POST',
        body: body.data,
        headers: {
            'Content-Type': 'application/json'
          },
      }),
    }),
    createPdf: builder.mutation<any, PdfCreateRequest>({
      query: (body) => ({
        url: 'pdf/create',
        method: 'POST',
        body,
      }),
    }),
    fetchAppSecurityCodes: builder.mutation<any, void>({
        query: () => ({
          url: 'Account/GetACL',
          method: 'GET',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
        }),
        transformResponse: (response: any) => {
            return response?.data || [];
          },
      }),
      fetchDynamicSection: builder.mutation({
        query: (params) => {
          const { url, method, data, contentType } = params;
          const config: any = {
            url,
            method,
            headers: {
              'Content-Type': contentType || 'application/json'
            }
          };
  
          // Only include body for non-GET requests with data
          if (method !== 'GET' && data) {
            config.body = JSON.stringify(data);
          }
  
          return config;
        }
      }),
      Searchables: builder.mutation<FindMenuItemsResponse, void>({
        query: (body) => ({
          url: '/Object/Searchables',
          method: 'GET',
        }),
        transformResponse: (response: any) => {
          return response.data ? response.data : [];
        },
      }),
    })
  });

export const { useFetchObjectMutation, useCreatePdfMutation,useFetchAppSecurityCodesMutation,useFetchDynamicSectionMutation,useSearchablesMutation } = objectViewerApi;
